var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-common" }, [
      _c("div", { staticClass: "flexStart" }, [
        _c("ul", { staticStyle: { "margin-right": "30px" } }, [
          _c("li", { staticClass: "pointer" }, [
            _vm._v("关于中国通用技术集团-中心采购平台")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "pointer" }, [_vm._v("公司介绍")]),
          _vm._v(" "),
          _c("li", { staticClass: "pointer" }, [_vm._v("诚聘英才")])
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", { staticClass: "pointer" }, [_vm._v("联系我们")]),
          _vm._v(" "),
          _c("li", [_vm._v("客服电话：010-87483355(周一至周五9:00-17:00)")]),
          _vm._v(" "),
          _c("li", [_vm._v("合作电话：010-87483355")]),
          _vm._v(" "),
          _c("li", [_vm._v("地址：北京市朝阳区望京保利国际T2座14层")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-bar" }, [
        _c("span", { staticStyle: { "margin-right": "20px" } }, [
          _vm._v("中国通用技术集团-中心采购平台科技有限公司")
        ]),
        _vm._v(
          "Copyright@2023 南阳商祺数贸科技有限公司 电话:400-0377-900\n    "
        ),
        _c("br"),
        _vm._v("版权所有豫ICP备2023000680号-2 豫ICP证B2-20231049号")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba0413ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0413ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/footer.vue
// module id = G58o
// module chunks = 1